import React from "react";

const SimpleTestimonial = () => {
  return (
    <div className="bg-gradient-to-b from-white via-gray-50/50 to-[#255262]/10 pt-16 md:pb-[100px] pb-[20px]">
      {/* <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="bg-white  shadow-sm p-8 max-w-2xl mx-auto">
          <div className="flex items-center justify-center mb-6">
            <div className="w-12 h-12 bg-[#255262] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
              <span className="text-white font-semibold text-sm">PT</span>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Philip Tan</h3>
              <p className="text-sm text-gray-500">CFO, IMC Industrial Group</p>
            </div>
          </div>

          <blockquote className="text-2xl font-light text-gray-800 italic leading-relaxed mb-8">
            "Going live is just the beginning."
          </blockquote>

          <a
            href="#"
            className="inline-flex items-center text-[#255262] font-medium transition-colors"
          >
            Watch their story (3:40)
            <svg
              className="w-4 h-4 ml-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default SimpleTestimonial;
